import { IntlShape } from 'react-intl';
import getLocalized, { Localized } from './Localized';
import { LanguageState, Locale, withCurrentLanguage } from './context';
import withLocalization from './withLocalization';

export { LanguageState, Locale, withCurrentLanguage, withLocalization };

interface GetValueFun<T, V> {
  (container: T): V | undefined;
}

function getValueForLocale<T, V>(
  locale: string, localized: Localized<T>, getValue: GetValueFun<T, V>): V | undefined {
  if (!localized) {
    return undefined;
  }
  const container = getLocalized(localized, locale) || undefined;
  return container
    ? getValue(container)
    : undefined;
}

function getLocalizedValue<T, V>(
  intl: IntlShape, localized: Localized<T>, getValue: GetValueFun<T, V>): V | undefined {

  return getValueForLocale(intl.locale, localized, getValue) ||
    getValueForLocale(intl.defaultLocale, localized, getValue);
}

export function getLocalizedStringWithDefault(intl: IntlShape, localized: Localized<string>,
  defaultValue: string): string {
  return getLocalizedValue<string, string>(intl, localized, x => x) || defaultValue;
}

export function getLocalizedStringWithDefaultLocale(intl: IntlShape, localized: Localized<string>,
  defaultValue: string): string {
  return getLocalizedValue<string, string>(intl, localized, x => x) || defaultValue;
}

export function getLocalizedString(
  intl: IntlShape, localized: Localized<string>): string {
  return getLocalizedStringWithDefault(intl, localized, "");
}

export function getLocalizedStringOrUndefined(
  intl: IntlShape, localized: Localized<string>): string | undefined {
  return getValueForLocale<string, string>(intl.locale, localized, x => x);
}
